import $ from 'jquery';
import '../components/index';

import './Home';
import './ImageSet';
import './Category';
import './Announce/index.scss';
import './Search/index.scss';

$(() => {
//
});




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/